module.exports = __webpack_public_path__ + "static/lauren-84e645c4518970c96024bd3b71653f46.png";